export enum RULE_TYPE {
  CREATE_EXCEPTION = 1,
  DO_NOT_CREATE_EXCEPTION = 2,
}

export enum CREADIT_OR_DEBIT {
  CREDIT = 1,
  DEBIT = 2,
  BOTH = 3,
}

export const creaditOrDebitOptions = [
  { label: 'Credit', value: CREADIT_OR_DEBIT.CREDIT },
  { label: 'Debit', value: CREADIT_OR_DEBIT.DEBIT },
  { label: 'Both', value: CREADIT_OR_DEBIT.BOTH },
]

export const ruleTypeOptions = [
  { label: 'Do Not Create Exceptions', value: RULE_TYPE.DO_NOT_CREATE_EXCEPTION },
  { label: 'Create Exceptions', value: RULE_TYPE.CREATE_EXCEPTION },
]
